module.exports = __webpack_public_path__ + "assets/img/1b39960a2697de9938ec259c4ee313b8.svg";